export const reportMessages: { [key: string]: string } = {
  success: "Report generation successful.",
  warning: "The report download failed.",
};
